<template>
  <div class="news">
    <meta-data v-if="page.metaTitle"
      :key="page.metaTitle"
      :meta-title="page.metaTitle"
      :meta-description="page.metaDescription"
      :no-index="page.noIndex"/>
    <page-header class="bg-default text-white" :headline="$t('news.title')" :sub-headline="$t('news.subTitle')" :break-after-to-white="true"></page-header>
    <div class="text-default bg-white padding--top-4 padding--bottom-8">
      <div class="container-fluid">
        <!-- Highlight news here -->
        <div class="row margin--bottom-4">
          <div v-for="(highlight, index) in news.highlights"
            :key="index"
            class="col-12">
            <div
              class="news__item news__item--highlight bgimg--hover"
              @click="$router.push({ name: $t('navigation.newsDetail'), params: { lang: $i18n.locale, slug: highlight.slug} })"
              :class="{ 'view': highlight.visible }"
              v-scroll:in="() => { highlight.visible = true; highlight.loaded = true }"
              v-scroll:out="() => highlight.visible = false">
              <span v-text="highlight.topline"/>
              <h3 v-text="highlight.headline"/>
              <div class="fade-in-child fade-in--right delay--100 box-shadow">
                <background-image
                  :scale="'16-9'"
                  :overlay="true"
                  :overlay-direction="'right'"
                  :url="highlight.image ? highlight.image.url : highlight.videoPosterImage ? highlight.videoPosterImage.url : null"
                  :video="highlight.cardVideo"
                  :loaded="highlight.loaded"/>
              </div>
            </div>
          </div>
        </div>
        <!-- NEWS HERE -->
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 margin--bottom-2" v-for="(news, index) in news.entries"
            :key="`news-entry-${index}`">
            <div
              :class="{ 'view': news.visible }"
              v-scroll:in="() => { news.visible = true; news.loaded = true }"
              v-scroll:out="() => news.visible = false">
                <news-entry :news="news"/>
            </div>
          </div>
        </div>
        <div
          class="row margin--top-2"
          :class="{ 'view': news.visible }"
          v-scroll:in="() => { news.visible = true; news.loaded = true }"
          v-scroll:out="() => news.visible = false">
          <div class="col-12 d-flex align-content-center justify-content-center fade-in-child fade-in--bottom">
            <button class="button-ghost news__load-more" v-if="this.currentCount !== this.totalCount" @click="loadMore()">
              {{ $t('news.loadMore') }}
            </button>
          </div>
          <div class="col-12 d-flex align-content-center justify-content-center margin--top-1 fade-in-child fade-in--bottom">
            <span>{{ this.currentCount }} {{ $t('news.of') }} {{ this.totalCount }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConst from '../config/app.const';
import MetaData from '../components/MetaData';
import BackgroundImage from '../components/layout/BackgroundImage';
import PageHeader from '../components/layout/PageHeader';
import Settings from '../config/settings';
import NewsEntry from '../components/news/NewsEntry';

const OFFSET = 0;
const TOTAL_COUNT = 0;
const COUNT = 9;

export default {
  name: 'News',
  components: { NewsEntry, PageHeader, BackgroundImage, MetaData },
  data () {
    return {
      news: {
        highlights: [],
        entries: []
      },
      offset: OFFSET,
      totalCount: TOTAL_COUNT,
      count: COUNT,
      page: {}
    };
  },
  computed: {
    newsLeft: function () {
      return this.totalCount - this.currentCount;
    },
    currentCount: function () {
      return this.news.entries.length;
    },
    currentOffset: function () {
      return this.totalCount - this.newsLeft;
    },
    queryNameNews: function () {
      return this.$store.getters['page/raceSeriesNews'];
    },
    queryNameNewsHighlights: function () {
      return this.$store.getters['page/raceSeriesNewsHighlights'];
    },
    queryNameNewsCount: function () {
      return this.$store.getters['page/raceSeriesNewsCount'];
    }
  },
  methods: {
    async fetchSystemPage () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: 'data?query=systemPages&slug=news',
        lifetime: Settings.LIFETIME_STATIC
      })
        .then(response => {
          this.page = response.systemPages[0];
        })
        .catch(() => {
          setTimeout(this.fetchSystemPage, 3000);
        });
    },
    async fetchHighlightNews () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryNameNewsHighlights}&count=1&offset=${this.offset}`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          response.newses.forEach((news) => {
            news.visible = false;
            news.loaded = false;
          });
          this.news.highlights = response.newses;
          this.fetchNews();
        })
        .catch(() => {
          setTimeout(this.fetchHighlightNews, 3000);
        });
    },
    async fetchNews () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryNameNews}&count=${this.count}&offset=0`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          response.newses.forEach((news) => {
            news.visible = false;
            news.loaded = false;
          });
          this.news.entries = response.newses;
        })
        .catch(() => {
          setTimeout(this.fetchNews, 3000);
        });
    },
    async fetchNewsCount () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryNameNewsCount}`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          this.totalCount = response.newsesConnection.aggregate.count;
        })
        .catch(() => {
          setTimeout(this.fetchNewsCount, 3000);
        });
    },
    async loadMore () {
      this.offset = this.currentOffset;
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryNameNews}&count=${this.count}&offset=${this.offset}`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          response.newses.forEach((news) => {
            news.visible = false;
            news.loaded = false;
            this.news.entries.push(news);
          });
          // handle some left over news and modify the default count and offset
          if (this.newsLeft < this.count) {
            this.count = this.newsLeft;
          }
          this.offset = this.offset + this.count;
        })
        .catch(() => {
          setTimeout(this.loadMore, 3000);
        });
    }
  },
  mounted () {
    this.fetchSystemPage();
    this.fetchHighlightNews();
    this.fetchNewsCount();
  }
};
</script>
